// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__zccB4","info":"Note_info__1CvTl","note":"Note_note__LACr7","actions":"Note_actions__1DtzG"};